/* eslint-disable no-unused-vars */
import React from "react";
import Dom from "../../assets/img/Home/Rectangle 4599.png";
import overlayImg from "../../assets/img/Login/Rectangle 4621.png";
import JobUpdates from "../../component/JobUpdates";
import Footer from "../../component/Footer";
import HeaderHome from "../../component/HeaderHome";
import DomiciliaryBanner from "../../../src/assets/img/Services/Banner image for clinical service for the website (2).png";
import ServiveImg from "../../../src/assets/img/Services/Frame 8480 (2).png";
import ServiveImg2 from "../../../src/assets/img/Services/Rectangle 24.png";
import patternImg1 from "../../../src/assets/img/Services/red-swirl (2).png";
import patternImg2 from "../../../src/assets/img/Services/blue-swirl 2 (1).png";
import sectionImg from "../../../src/assets/img/Services/seaction(4).jpg";
import sectionImg2 from "../../../src/assets/img/Services/seaction(5).jpg";
import sectionImg3 from "../../../src/assets/img/Services/BgImage1234.jpeg";
import bgImg from "../../../src/assets/img/Services/Group 2528.png";
import FeatureIcon from "../../../src/assets/Icons/icon-3.png";
import FeatureIcon2 from "../../../src/assets/Icons/icon-3 (1).png";
import FeatureIcon3 from "../../../src/assets/Icons/icon-3 (2).png";
import sectionImg4 from "../../../src/assets/img/Services/BgImage123.jpeg";
import sectionImg5 from "../../../src/assets/img/Services/image 62.png";
import sectionImg6 from "../../../src/assets/img/Services/1f0046cfa05994fbca39385556e892bb805c8b20.jpg";
import EpilepsyImg from '../../../src/assets/img/Services/image (1).png'
import CerebralPalsyImg from '../../../src/assets/img/Services/image (2).png'
import MultipleSclerosisImg from '../../../src/assets/img/Services/image (3).png'
import StrokeImg from '../../../src/assets/img/Services/image (4).png'
import CancerImg from '../../../src/assets/img/Services/image (5).png'

function Domiciliary() {
  return (
    <div className="bg-[#F9F9FA] overflow-x-hidden">
      <HeaderHome />
      <div className="relative mt-8">
        <img
          className="w-full min-h-[298px] bottom-0 object-cover z-0 pointer-events-none"
          src={DomiciliaryBanner}
          alt="Vacancy Background"
        />

   <div className="absolute inset-0 flex flex-col items-center justify-center text-white px-4">
  <h1 className="text-center tracking-wider font-oregon_black font-medium text-[28px] sm:text-[30px] md:text-[30px] lg:text-[30px] leading-tight">
    Domiciliary Care
  </h1>

  <p className="mt-4 sm:mt-6 font-oregon_black font-medium tracking-wider text-[18px] sm:text-[20px] md:text-[24px] lg:text-[30px] leading-snug sm:leading-normal text-center sm:text-left max-w-[90%] sm:max-w-2xl lg:max-w-4xl lg:mr-36 sm:mr-20">
    Innovative Services and Solutions for a Healthier Tomorrow
  </p>
</div>

      </div>
      <div className="mt-16 mx-auto px-4 lg:px-[50px]  justify-center w-full h-full">
        <div className="w-full">
          {/* <div data-aos="zoom-in" className="relative w-full flex items-center justify-center">
          <div className="relative w-full h-full flex items-center justify-center">
          <div className='absolute text-[#FFFFFF] text-[24px] sm:text-[50px] md:text-[70px] lg:text-[90px] font-normal z-20'>Domiciliary Care</div>
            <img src={Dom} alt="Login" className='w-full h-full' />
            <div className="absolute inset-0 bg-transparent">
              <img src={overlayImg} alt="Overlay" className="rounded-xl w-full h-full" />
            </div>
          </div>
        </div> */}
          {/* <h1 className="mt-12 font-bold text-6 mb-2"><span className="home-text"></span></h1> */}
          <div className="my-[50px] mx-auto flex flex-col lg:grid lg:grid-cols-[56%_44%]  gap-x-10 w-full">
            <div>
              <h3 data-aos="fade-up" className="mt-12 service-text11 mb-2">
                <span className="">Personal care</span>
              </h3>
              <p data-aos="zoom-in" className="text-3-corpo-soft mt-12">
                RHC 360 Solutions offers personal care services that always
                ensure your safety and wellbeing. Our well trained and qualified
                staff consist of professional experience and skills in aiding
                you with the maintenance of your daily tasks with privacy,
                comfort, and convenience.
              </p>
              <p data-aos="zoom-in" className="service-text3 mt-8">
                Our exceptional personal{" "}
                <span className="text-[#0082DA]">care services include:</span>
              </p>
              <ul
                data-aos="zoom-in"
                className="mt-5 ml-5 list-disc text-3-corpo-soft"
              >
                <li className="mb-2">Helping to and from bed</li>
                <li className="mb-2">
                  Help with washing, dressing, bathing, and showering
                </li>
                <li className="mb-2">Oral hygiene and skin care</li>
                <li className="mb-2">Stoma and catheter care.</li>
                <li className="mb-2">Refreshing continence pads</li>
                <li className="mb-2">Aid with toileting needs</li>
                <li className="mb-2">Meal preparation and feeding</li>
                <li className="mb-2">Aid and prompting of medication</li>
              </ul>
            </div>
           <div className="relative w-full max-w-5xl mx-auto overflow-hidden">
  {/* Background Pattern */}
  <img
    src={patternImg1}
    alt="patternImage"
    className="absolute inset-0 w-full h-full object-cover z-0 pointer-events-none"
  />

  {/* Foreground Image */}
  <img
    src={ServiveImg}
    alt="ServiceImage"
    className="relative z-10 object-cover pointer-events-none mt-16 md:mt-32 lg:mt-10 w-full max-w-[90%] sm:max-w-[650px] mx-auto"
  />
</div>

          </div>

        <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 gap-6 justify-items-center">
  {/* Card 1 */}
<div className="relative group w-full max-w-sm h-[400px] rounded-lg overflow-hidden">
  <img
    src={sectionImg}
    alt="ServiceImage"
    className="object-cover w-full h-full transition-transform duration-500"
  />
  
  {/* Fix: Ensure this gradient div appears over the image */}
  <div className="absolute inset-0 z-10 bg-black/60 opacity-95" />
  <h1 className="absolute inset-0 z-20 flex items-center text-center justify-center text-white font-oregon text-[30px] md:text-[35px] lg:text-[40px] font-[700] group-hover:hidden">
  Respite care
</h1>

  {/* Content overlay on hover */}
  <div className="absolute inset-0 z-20 bg-black/30 opacity-0 group-hover:opacity-100 transition duration-300 flex flex-col  p-6 text-white">
    <h3 className="text-2xl font-semibold  font-oregon mb-2 tracking-wider">Respite care</h3>
    <p className="text-[15px] sm:text-[18px] font-oregon leading-relaxed">Our respite care services offer you the convenience of having our help regardless of a time limit, whether it is one hour or half a day, you can step out rest assured your family member is well cared for. We will discuss your specific concerns and requirements and offer you personalised service package that will relieve you to attend to your personal needs. Our staff will ensure the safety and wellbeing of your family member until you are ready to take over.</p>
  </div>
</div>


  {/* Card 2 */}
<div className="relative group w-full max-w-sm h-[400px] rounded-lg overflow-hidden">
  {/* Background Image */}
  <img
    src={sectionImg2}
    alt="ServiceImage"
    className="object-cover w-full h-full transition-transform duration-500"
  />

  {/* Black overlay */}
  <div className="absolute inset-0 z-10 bg-black/60 opacity-95" />

  <h1 className="absolute inset-0 z-20 text-center flex items-center justify-center text-white font-oregon text-[30px] md:text-[35px] lg:text-[40px] font-[700] group-hover:hidden">
  Palliative care
</h1>

  {/* Content on hover */}
  <div className="absolute inset-0 z-30 bg-black/30 opacity-0 group-hover:opacity-100 transition duration-300 flex flex-col  p-6 text-white">
    <h3 className="text-2xl font-semibold  font-oregon mb-2 tracking-wider">Palliative care</h3>
    <p className=" text-[15px] sm:text-[18px] font-oregon leading-relaxed">We have specialised teams dedicated to providing care for patients with terminal or life-threatening conditions. While some conditions may not be curable, our care focuses on enhancing the quality of life for both our clients and their loved ones.</p>
  </div>
</div>


  {/* Card 3 */}
  <div className="relative group w-full max-w-sm h-[400px] rounded-lg overflow-hidden">
    <img
      src={sectionImg3}
      alt="ServiceImage"
      className="object-cover w-full h-full  transition-transform duration-500"
    />
    <div className="absolute inset-0 z-10 bg-black/60 opacity-95" />
   <h1 className="absolute inset-0 z-20 flex items-center text-center justify-center text-white font-oregon text-[30px] md:text-[35px] lg:text-[40px] font-[700] group-hover:hidden">
 Mental Health care
</h1>
   <div className="absolute inset-0 z-20 bg-black/30 opacity-0 group-hover:opacity-100 transition duration-300 flex flex-col  p-6 text-white">
    <h3 className="text-2xl font-semibold  font-oregon mb-2 tracking-wider">Mental Health care</h3>
    <p className="text-[15px] sm:text-[18px] font-oregon leading-relaxed">We support individuals with mental health conditions, providing active assistance for both short- and long-term challenges.</p>
  </div>
  </div>
</div>


          {/* <h3 data-aos="fade-up" className="mt-12 font-bold text-5 mb-2"><span className="">Respite care</span></h3>
          <p data-aos="zoom-in" className="text-3 mt-12">Our respite care services offer you the convenience of having our help regardless of a time limit, whether it is one hour or half a day, you can step out rest assured your family member is well cared for. We will discuss your specific concerns and requirements and offer you personalised service package that will relieve you to attend to your personal needs. Our staff will ensure the safety and wellbeing of your family member until you are ready to take over.</p> */}

          <div className="my-[50px]  mx-auto px-4  flex flex-col lg:grid lg:grid-cols-[56%_44%]  gap-x-10 w-full">
            <div>
              <h3 data-aos="fade-up" className="mt-12 service-text3 mb-2">
                24 Hour <span className="text-[#0082DA]">Live-in care</span>
              </h3>
              <ul className="mt-5 ml-5 list-disc text-3-corpo-soft">
                <li data-aos="zoom-in" className="mb-2">
                  As our name suggests; RHC 360 Solutions, our live-in care
                  solutions are offered around the clock any day of the week.
                  Our rotational shifts ensure efficiency of our staff members,
                  delivering quality and uncompromised care. Live-in care
                  depicts a dedicated carer living at your home taking turns
                  with a relieving carer to attend to your needs.
                </li>
                <li data-aos="zoom-in" className="mb-2">
                  You are free to discuss with us how you want the rotation of
                  the carers to split, to ensure the 24-hour frame is covered.
                  Moreover, we offer you the choice of selecting the preferred
                  carer profile to help you feel more comfortable at your own
                  home.
                </li>
                <li data-aos="zoom-in" className="mb-2">
                  Night shifts can vary from a late start to wake-in and
                  sleepover shifts. The charges are calculated based on a weekly
                  care plan. This type of plan is typically referred to social
                  services, however you also can self-fund the live-in care
                  service by discussing with our consultants on how best we can
                  support you.
                </li>
              </ul>

               <div data-aos="zoom-in" className='mt-12 flex justify-center mb-6 lg:mb-0 '>
            <a href="/ContactUs" target="blank" className="bg-[#0082DA] text-[20px] text-white  font-corpo py-2 px-5 lg:py-3 lg:px-6 rounded-[10px]">Book Appointment</a>
          </div>
            </div>
           <div className="relative w-full max-w-5xl mx-auto overflow-hidden">
  {/* Background Pattern */}
  <img
    src={patternImg2}
    alt="patternImage"
    className="absolute inset-0 w-full h-full object-cover z-0 pointer-events-none"
  />

  {/* Foreground Image */}
  <img
    src={ServiveImg2}
    alt="ServiceImage"
    className="relative z-10 object-cover pointer-events-none mt-16 md:mt-32 lg:mt-10 w-full max-w-[90%]  sm:max-w-[650px] mx-auto"
  />
</div>

          </div>

          {/* <h3 data-aos="fade-up" className="mt-12 font-bold text-5 mb-2"><span className="">Palliative care</span></h3>
          <p data-aos="zoom-in" className="text-3 mt-12">We have specialized teams dedicated to providing care for patients with terminal or life-threatening conditions. While some conditions may not be curable, our care focuses on enhancing the quality of life for both our clients and their loved ones.</p> */}

          <h3
            data-aos="fade-up"
            className="mt-12 service-text11 text-center mb-2"
          >
            Our <span className="text-[#0082DA]">Capabilities</span>
          </h3>

          <div className="grid  gap-14 py-[80px]  grid-cols-1 sm:grid-cols-1 md:grid-cols-2  lg:grid-cols-3 justify-items-center lg:justify-items-start">
            <div className="relative max-w-[373px] lg:min-h-[361px] flex flex-col px-5 py-4 h-auto  rounded-2xl overflow-hidden">
              {/* Background image as overlay */}
              <img
                src={bgImg}
                alt="Background Overlay"
                className="absolute inset-0 w-full h-full object-cover z-0"
              />

              {/* Content layer */}
              <div className="relative z-10">
                <img
                  src={FeatureIcon}
                  alt="Icon"
                  className="object-cover w-[60px] h-[60px] sm:w-[80px] sm:h-[80px]"
                />
                <p className="service-text-10 min-h-[62px] mt-3">
                  Qualified Carers
                </p>
                <p className="text-5-corpo-soft ">
                  Our trained carers deliver high-quality care at home.
                </p>
              </div>
            </div>

            <div className="relative max-w-[373px] lg:min-h-[361px]  flex flex-col px-5 py-4  h-auto  rounded-2xl overflow-hidden ">
              {/* Background image as overlay */}
              <img
                src={bgImg}
                alt="Background Overlay"
                className="absolute inset-0 w-full h-full object-cover z-0"
              />

              <div className="relative z-10">
                <img
                  src={FeatureIcon2}
                  alt="Icon"
                  className="object-cover w-[60px] h-[60px] sm:w-[80px] sm:h-[80px]"
                />
                <p className=" service-text-10 mt-3 min-h-[62px]">
                  Personalised Care Plans
                </p>
                <p className="text-5-corpo-soft">
                  Each client receives a tailored plan that respects their
                  unique needs and preferences.
                </p>
              </div>
            </div>
            <div className="relative max-w-[373px] lg:min-h-[361px] h-auto flex flex-col px-5 py-4   rounded-2xl overflow-hidden ">
              {/* Background image as overlay */}
              <img
                src={bgImg}
                alt="Background Overlay"
                className="absolute inset-0 w-full h-full object-cover z-0"
              />
              <div className="relative z-10">
                <img
                  src={FeatureIcon3}
                  alt="Icon"
                  className="object-cover w-[60px] h-[60px] sm:w-[80px] sm:h-[80px]"
                />
                <p className="service-text-10 mt-3 min-h-[62px]">
                  Emotional Support
                </p>
                <p className="text-5-corpo-soft">
                  We help families in discussing feelings and provide
                  bereavement support.
                </p>
              </div>
            </div>
          </div>

          <h3 data-aos="fade-up" className="mt-12 service-text11 ">
            Dementia <span className="text-[#0082DA]">Care</span>
          </h3>
          <p data-aos="zoom-in" className="text-3-corpo-soft mt-3">
            At RHC 360 Solutions, our staff are trained to support clients at
            all stages of dementia, ensuring familiarity and security in care.
          </p>

          <div className="flex flex-col md:flex-row w-full mt-3 ">
            {/* Left large image */}
            <div className=" relative w-full md:w-[60%] h-[400px] md:h-auto">
              <img
                src={sectionImg4}
                alt="SectionImage"
                className="w-full h-full object-cover pointer-events-none"
              />
               <div className="absolute inset-0 bg-gradient-to-b from-[#00000000] to-[#000000] opacity-80" />
              <div className="absolute bottom-6 left-6 z-10">
                <h3 className="service-text12">Consistent Care Staff</h3>
                <p className="text-7-corpo-soft mt-3">
                  Clients are cared for by the same staff to foster comfort.
                </p>
              </div>
            </div>

            {/* Right column of 2 images */}
            <div className="w-full md:w-[40%] flex flex-col">
              <div className="h-[400px] relative md:h-1/2">
                <img
                  src={sectionImg6}
                  alt="SectionImage"
                  className="w-full h-full object-cover pointer-events-none"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#00000000] to-[#000000] opacity-60" />
                <div className="absolute bottom-6 left-6 z-10">
                  <h3 className="service-text12">Specialised Training</h3>
                  <p className="text-7-corpo-soft mt-3">
                    Our caregivers can handle the complexities of dementia.
                  </p>
                </div>
              </div>
              <div className=" relative h-[400px] md:h-1/2">
                <img
                  src={sectionImg5}
                  alt="SectionImage"
                  className="w-full h-full object-cover pointer-events-none"
                />
                <div className="absolute bottom-6 left-6 z-10">
                  <h3 className="service-text12">Needs Assessment</h3>
                  <p className="text-7-corpo-soft mt-3">
                    We conduct detailed assessments to create meaningful care
                    plans.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <h3 data-aos="fade-up" className="mt-12 service-text3 mb-2">
            End-of-<span className="text-[#0082DA]">Life Care</span>
          </h3>
          <p data-aos="zoom-in" className="text-3-corpo-soft mt-12">
            We understand the sensitivity of individuals coping with progressive
            or incurable illness. That is why we offer personalised end-of-life
            care for individuals, allowing them to spend their time at the
            comfort of their home with their loved ones.
          </p>
          <p data-aos="zoom-in" className="service-text13 mt-8 text-center">
            Our services ranges from
          </p>
          <div className="grid  gap-14 py-[80px]   grid-cols-1 sm:grid-cols-2 md:grid-cols-2  lg:grid-cols-4 justify-items-center lg:justify-items-start">
            <div className="relative bg-white max-w-[360px] lg:max-w-[292px]  min-h-[238px] flex flex-col px-5 py-4  rounded-2xl overflow-hidden">
              {/* Content layer */}
              <div className="relative z-10">
                <p className="service-text-10 min-h-[62px] mt-3">
                  Collaboration with Healthcare Teams
                </p>
                <p className="text-5-corpo-soft mt-3 ">
                  We coordinate with NHS and hospital staff for seamless care
                  transitions.
                </p>
              </div>
            </div>

            <div className="relative max-w-[360px] lg:max-w-[292px] min-h-[238px] bg-white   flex flex-col px-5 py-4   rounded-2xl overflow-hidden">
              <div className="relative z-10">
                <p className=" service-text-10 mt-3 min-h-[62px]">
                  Emergency Care Arrangements
                </p>
                <p className="text-5-corpo-soft mt-3">
                  We can implement care quickly as needed.
                </p>
              </div>
            </div>
            <div className="relative max-w-[360px] lg:max-w-[292px] min-h-[238px] bg-white   flex flex-col px-5 py-4   rounded-2xl overflow-hidden ">
              <div className="relative z-10">
                <p className="service-text-10 mt-3 min-h-[62px]">
                  Focus on Comfort
                </p>
                <p className="text-5-corpo-soft mt-3">
                  Our trained staff ensure clients are comfortable during this
                  challenging time
                </p>
              </div>
            </div>
            <div className="relative max-w-[360px] lg:max-w-[292px]  min-h-[238px] bg-white  flex flex-col px-5 py-4   rounded-2xl overflow-hidden ">
              <div className="relative z-10">
                <p className="service-text-10 mt-3 min-h-[62px]">
                  Physical Disabilities Care
                </p>
                <p className="text-5-corpo-soft mt-3">
                  We provide support for individuals with various physical
                  disabilities, helping them with daily tasks.
                </p>
              </div>
            </div>
          </div>
          <h3 data-aos="fade-up" className="mt-12 service-text3 mb-2 text-center lg:text-left">
            Other Conditions<span className="text-[#0082DA]"> Supported</span>
          </h3>

          <div className="grid  gap-10  grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 justify-items-center lg:justify-items-start">
            <div className="relative bg-white max-w-[233px] min-h-[190px] flex flex-col p-2 rounded-2xl overflow-hidden">
              {/* Content layer */}
              <div className="relative z-10">
                <img
                  src={EpilepsyImg}
                  alt="Epilepsy"
                  className=" w-[198px] overflow-hidden border object-cover pointer-events-none"
                />
               
                <p className="text-8-corpo-soft mt-3 text-center ">
                 Epilepsy
                </p>
              </div>
            </div>

            <div className="relative max-w-[233px] min-h-[190px] bg-white   flex flex-col p-2   rounded-2xl overflow-hidden ">
              <div className="relative z-10">
                 <img
                  src={CerebralPalsyImg}
                  alt="CerebralPalsy"
                  className=" w-[198px] overflow-hidden border object-cover pointer-events-none"
                />
                <p className="text-8-corpo-soft mt-3 text-center">
                 Cerebral Palsy
                </p>
              </div>
            </div>
            <div className="relative max-w-[233px] min-h-[190px] bg-white   flex flex-col p-2   rounded-2xl overflow-hidden ">
              <div className="relative z-10">
                 <img
                  src={MultipleSclerosisImg}
                  alt="MultipleSclerosis"
                  className=" w-[198px] overflow-hidden border object-cover pointer-events-none"
                />
                <p className="text-8-corpo-soft mt-3 text-center">
                 Multiple Sclerosis
                </p>
              </div>
            </div>
            <div className="relative max-w-[233px] min-h-[190px] bg-white  flex flex-col p-2   rounded-2xl overflow-hidden ">
              <div className="relative z-10">
                 <img
                  src={StrokeImg}
                  alt="Stroke"
                  className=" w-[198px] overflow-hidden border object-cover pointer-events-none"
                />
                <p className="text-8-corpo-soft mt-3 text-center">
                 Stroke
                </p>
              </div>
            </div>
                   <div className="relative max-w-[233px] min-h-[190px] bg-white  flex flex-col p-2   rounded-2xl overflow-hidden ">
              <div className="relative z-10">
                 <img
                  src={CancerImg}
                  alt="Cancer"
                  className=" w-[198px] overflow-hidden border object-cover pointer-events-none"
                />
                <p className="text-8-corpo-soft mt-3 text-center">
                 Cancer
                </p>
              </div>
            </div>
              
          </div>
          <h3 data-aos="fade-up" className="mt-12 service-text3 mb-2">
            Learning<span className="text-[#0082DA]"> Disabilities </span>Support
          </h3>
          <p data-aos="zoom-in" className="text-3-corpo-soft mt-5">
            Our team helps adults with learning disabilities,
            helping them with everyday tasks.
          </p>
          <p data-aos="zoom-in" className="text-3-corpo-soft mt-3 ">
            Areas of Focus:
          </p>
          <ul data-aos="zoom-in" className="mt-3 ml-5 list-disc text-3-corpo-soft">
            <li className="mb-2">Dyslexia</li>
            <li className="mb-2">ADHD</li>
            <li className="mb-2">Non-verbal communication.</li>
          </ul>
        </div>
      </div>
      {/* <div className="mx-[40px] my-[100px]">
        <JobUpdates />
      </div> */}
      <Footer />
    </div>
  );
}

export default Domiciliary;
